<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>反向报警数据</span>
          <div class="toolbar-items">
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="报警编码" class="detail-form-item">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                 <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="报警名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="数据状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.dataState">
                        <el-option v-for="item in dataStates" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="观察点名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.node.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="观察目标名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.nodeDetail.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="摄像机名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.camera.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航路线名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.cruise.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="报警时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.warnTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="风险等级" class="detail-form-item">
                      <el-input size="medium" v-model="entity.level"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="目标识别数量" class="detail-form-item">
                      <el-input size="medium" v-model="entity.diffCount"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="视频开始时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.beginRecordTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="视频结束时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.endRecordTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="视频时长" class="detail-form-item">
                      <el-input size="medium" v-model="entity.second"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="上报状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.submitState">
                        <el-option v-for="item in submitStates" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="上报时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.submitTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="上报反馈" class="detail-form-item">
                      <el-input type="textarea" rows="5" v-model="entity.submitResult"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" rows="5" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="报警原始图">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-image style="width: 1200px; height: 600px" :src="entity.sourcePicPath" fit="contain"></el-image>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="目标识别图">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-image style="width: 1200px; height: 600px" :src="entity.warnResultPicPath" fit="contain"></el-image>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="报警视频">
        <div class="detail-containe-product">
          <el-scrollbar>
            <video v-if="entity.videoPath" width="800" height="600" controls>
              <source :src="entity.videoPath">
            </video>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createWarnContext } from "@/script/apps/recon/config/ReconConfig";
import { Warn } from "@/script/apps/recon/entity/ReconEntity";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";

@Options({})
export default class WarnDetail extends BaseDetail {
  private dataStates: Dict[] = [];
  private submitStates: Dict[] = [];

  public initData(): ServiceContext {
    return createWarnContext();
  }

  public newEntity() {
    const entity: Warn = {
      node: { name: "" },
      camera: { name: "" },
      cruise: { name: "" },
      nodeDetail: { name: "" },
    };
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const dictService = new DictService();
    dictService.loadChildItems("rec-warn-data-state", (data: any) => {
      this.dataStates = data;
    });
    dictService.loadChildItems("rec-warn-submit-state", (data: any) => {
      this.submitStates = data;
    });
  }
}
</script>

<style lang="scss">
</style>
